import {
  mdiArrowDownBold,
  mdiArrowUpBold,
  mdiCached,
  mdiCalendar,
  mdiCalendarClock,
  mdiCalendarMultipleCheck,
  mdiCheck,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiCloseCircle,
  mdiCloseCircleOutline,
  mdiCloseThick,
  mdiDownload,
  mdiEmailSend,
  mdiEye,
  mdiEyeOff,
  mdiFilterMenuOutline,
  mdiFormatQuoteClose,
  mdiFormatQuoteOpen,
  mdiLightbulbOutline,
  mdiMinus,
  mdiPdfBox,
  mdiPencil,
  mdiPercent,
  mdiPlusThick,
  mdiRefresh,
  mdiSwapVerticalBold,
  mdiSync,
  mdiTrashCan,
} from "@mdi/js"
import {
  siBubbles,
  siCalculator,
  siCalender,
  siCloudUpload,
  siPhone,
  siQuestion,
  siStar,
} from "vendor/fonts/icons/simple-line-icons/fonts/Simple-Line-Icons"
import {
  imAdd,
  imBarChart4,
  imBasketCoins,
  imBusinessManWoman,
  imClose,
  imCoins,
  imConsulting,
  imDanger,
  imDataCloud,
  imDataDownload,
  imDiamond,
  imDollarSign2,
  imDownload,
  imEngineering,
  imFemale,
  imFileEdit,
  imFiles,
  imFinancial,
  imGear,
  imGears,
  imGrave,
  imInformation,
  imLifeSafer,
  imLineChart1,
  imMailLock,
  imMale,
  imMaleFemale,
  imMapMarker,
  imMoneyBag,
  imMonitorAnalytics,
  imNotepad,
  imOptimization,
  imPieChart3,
  imPolice,
  imRefresh,
  imRemove,
  imScale,
  imSecuritySettings,
  imSpeachBubble13,
  imSpring,
  imStart1,
  imStop,
  imSun,
  imTrashWithMen,
  imTrophy,
  imUmbrella2,
  imUpload,
  imUpload1,
  imUser,
} from "vendor/fonts/icons/iconsmind-s/font/iconsminds"

export const icons = <const>{
  mdiArrowUpBold,
  mdiArrowDownBold,
  mdiCalendar,
  mdiCalendarClock,
  mdiChevronLeft,
  mdiSwapVerticalBold,
  mdiLightbulbOutline,
  mdiChevronRight,
  mdiChevronDown,
  mdiChevronUp,
  mdiFilterMenuOutline,
  mdiFormatQuoteOpen,
  mdiFormatQuoteClose,
  mdiPercent,
  mdiCloseCircleOutline,
  mdiEye,
  mdiEyeOff,
  mdiPencil,
  mdiMinus,
  mdiCheck,
  mdiTrashCan,
  mdiPlusThick,
  mdiCloseThick,
  mdiCloseCircle,
  mdiRefresh,
  mdiCached,
  mdiSync,
  mdiPdfBox,
  mdiEmailSend,
  mdiCalendarMultipleCheck,
  mdiDownload,
  /* iconsminds */
  imAdd,
  imRemove,
  imBarChart4,
  imBusinessManWoman,
  imConsulting,
  imDownload,
  imDataDownload,
  imDataCloud,
  imDiamond,
  imEngineering,
  imFinancial,
  imGear,
  imGears,
  imInformation,
  imMoneyBag,
  imMonitorAnalytics,
  imNotepad,
  imPolice,
  imRefresh,
  imSpeachBubble13,
  imSpring,
  imTrashWithMen,
  imStart1,
  imStop,
  imMaleFemale,
  imBasketCoins,
  imCoins,
  imLifeSafer,
  imPieChart3,
  imSun,
  imUser,
  imOptimization,
  imMapMarker,
  imSecuritySettings,
  imClose,
  imUpload,
  imUpload1,
  imGrave,
  imFiles,
  imMale,
  imFemale,
  imDollarSign2,
  imTrophy,
  imDanger,
  imUmbrella2,
  imScale,
  imLineChart1,
  imMailLock,
  imFileEdit,
  /* simple line icons */
  siStar,
  siQuestion,
  siCalender,
  siBubbles,
  siCalculator,
  siPhone,
  siCloudUpload,
  imTest:
    "M1094 109c-12 0-21-9-21-21 0-101-166-186-271-186-9 0-17-5-20-14l-41-123c-4-11 2-23 13-27 11-3 23 3 26 13l37 111c123 7 298 102 298 226 0 12-10 21-21 21zM677-221c-11 0-21-10-21-21s10-21 21-21c203 0 284-100 310-143-19-32-71-121-80-161-17-70-72-232-230-232-11 0-21-9-21-20 0-12 10-21 21-21 132 0 231 96 270 263 9 35 62 127 81 160 4 6 4 13 1 19-21 42-108 177-352 177zm-333 82c-123 0-219-130-229-249-43-6-63-33-63-60v-83c0-25 25-44 42-54v-69c0-74 24-143 201-145 60-42 117-51 155-51 74 0 138 33 162 84 18 38 11 80-18 119v62c16 10 41 28 41 54v83c0 27-19 54-63 60-9 119-106 249-228 249zm106-670c-33 0-83 8-135 47-4 3-8 5-13 5-167 0-167 57-167 103v82c0 8-4 16-12 19-15 7-28 18-29 23v82c0 15 22 21 41 21 12 0 21 9 21 20 0 103 84 227 188 227s187-124 187-227c0-11 10-20 21-20 19 0 42-6 42-21v-83c-1-4-16-16-30-22-7-3-12-11-12-19v-82c0-5 2-10 5-14 23-27 29-55 17-80-17-36-67-61-124-61zM-94 150c-11 0-21-9-21-21V88c0-119 97-206 230-206h51l60-88c6-10 19-12 29-6 9 6 12 19 5 28l-66 98c-3 6-10 9-17 9h-62C4-77-73-9-73 88v41c0 12-9 21-21 21zm875 0c-11 0-21-9-21-21V88c0-97-75-165-184-165h-62c-7 0-13-3-17-9l-68-97c-6-10-4-22 5-29 10-6 23-4 29 5l62 89h51c133 0 226 85 226 206v42c0 11-9 20-21 20z|0 -850 1000 1000",
}
